// Shared date formatting helpers (string-only; no Date conversion)

/**
 * Formats common API date strings to MM/DD/YYYY.
 *
 * Accepts:
 * - "YYYY-MM-DD"
 * - "YYYY-MM-DDTHH:mm:ss..." (uses the date part)
 * - "YYYY-MM-DD HH:mm:ss" (uses the date part)
 *
 * If the input doesn't match a supported pattern, returns the original trimmed value.
 */
export function formatDateMMDDYYYY(value) {
    const raw = String(value ?? "").trim();
    if (!raw) return "";

    // Pull the date portion if time is present.
    const datePart = raw.split("T")[0].split(" ")[0].trim();

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(datePart)) return datePart;

    const m = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return raw;

    const yyyy = m[1];
    const mm = m[2];
    const dd = m[3];
    return `${mm}/${dd}/${yyyy}`;
}
